import { Stack, Pagination } from "@mui/material"
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
// Updated HTTP Import
import { getKREDomainsHttp } from "../../../http/renewalHttp/RenewalHttp";

export default function RenewalMeetings() {
    const [customerList, setCustomerList] = useState([]);
    const [initailCustomerList, setInitialCustomerList] = useState([])
    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Renamed fetch function specifically for KRE Domains
    const getKREDomains = useCallback(async () => {
        const response = await getKREDomainsHttp(); 
        if (response) {
            // response.customer should contain the list of domains
            setCustomerList(response.customer);
            setInitialCustomerList(response.customer);
        } else {
            setCustomerList([]);
            setInitialCustomerList([]);
        }
    }, []);

    useEffect(() => {
        getKREDomains();
    }, [getKREDomains])

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    
    function handleSearchCustomer(event) {
        const search_item = event.target.value;
        const filteredList = initailCustomerList.filter((customer) => {
            if (customer && customer.customerDomain) {
                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            return false;
        });
        setCustomerList(filteredList);
        setSearch(search_item);
        setCurrentPage(1); 
    }

    return (
        <>
            <PageTitle title={`Renewal Meetings`} />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">
                    <Div className="btn-group toolbar-item" role="group" >
                        <Input 
                            type='text' 
                            placeholder="Search Customer Domain..."
                            name='text' 
                            id='text' 
                            style={{ marginLeft: '50px', width: '300px' }} 
                            value={search}
                            onChange={handleSearchCustomer}
                        />
                    </Div>
                </Div>
            </Div>

            <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                {customerList.length > 0 ? (
                    <table className="table" border="1">
                        <thead>
                            <tr>
                                <th>Customer Domain</th>
                                <th>Reseller</th>
                                <th>Zone</th>
                                <th>Google Renewal Date</th>
                                <th>Price</th>
                                <th>Segments</th>
                                <th>Assigned to</th>
                            </tr>
                        </thead>
                        <tbody id="tableBody">
                            {currentItems.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.customerDomain}</td>
                                    <td>{customer.reseller_type}</td>
                                    <td>{customer.zone_update}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{customer.segments}</td>
                                    <td>{customer.assigned_to}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p style={{ marginTop: '30px' }}>No Domain Present or Could not fetch Domains</p>
                )}

                {customerList.length > 0 && (
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate} />
                    </Stack>
                )}
            </Div>
        </>
    );
}